<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content buddy-content" @click="closeLevel2()">
      <student-header class="filled" :navbarmode.sync="navbarMode" ref="lmsv4header" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-20">
          <div class="d-flex align-items-center mg-b-20">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style4 mg-b-10">
                <!-- <li class="breadcrumb-item"><router-link :to="{ name: 'buddyParticipant' }" class="tx-11" style="color: #444">Onboarding</router-link></li> -->
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyAdminDashboard' }" class="tx-11" style="color: #444">Onboarding</router-link></li>
                <li class="breadcrumb-item active tx-14" aria-current="page">Шинэ ажилтан</li>
              </ol>
            </nav>
            <div class="mg-l-auto d-flex align-items-center">
              <div class="mg-x-5">
                <depart-cascader2 v-model="listFilter.departId" :key="listFilterDepartKey" @on-change="departListChanged" checkStrictly size="large" ></depart-cascader2>
              </div>
              <!-- <div class="tggler">
                <div @click="mdlUpdateBuddy= true" class="pd-x-20 pd-y-8" role="button">
                  <feather type="plus"></feather>
                  Buddy нэмэх
                </div>
              </div> -->
              <div v-if="buddiesFetched && buddiesAllCount>0 && buddiesAllCount!=buddies.length" class="tggler mg-l-10">
                <div @click="init(true)" class="pd-x-20 pd-y-8" role="button">
                  <feather type="list"></feather>
                  Бүгд ({{ buddiesAllCount }})
                </div>
              </div>
            </div>
          </div>
          

          <table class="wd-100p tbl-buddy">
            <thead>
              <tr>
                <th>Овог, нэр
                  <feather @click="openFilterModal(1)" type="search" class="mg-l-5" role="button"></feather>
                </th>
                <th>
                  Домайн
                  <feather @click="openFilterModal(2)" type="search" class="mg-l-5" role="button"></feather>
                </th>
                <th>Ажилд орсон огноо</th>
                <th>Төлөв</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr v-if="loading">
                <td colspan="7">
                  <div class="alert alert-secondary mg-t-10" role="alert">
                    Түх хүлээнэ үү.
                  </div>
                </td>
              </tr>
              <tr v-else-if="buddies.length<=0">
                <td colspan="7">
                  <div class="alert alert-secondary mg-t-10" role="alert">
                    Мэдээлэл хоосон байна.
                  </div>
                </td>
              </tr>
              <tr v-else @click="gotoBuddyDetail(b)" v-for="(b, bi) in buddies" role="button">
                <td>
                  <div class="d-flex mg-y-6">
                    <div class="mg-r-10">
                      <img :src="`${b.avator}`" class="wd-40 rounded-circle" />
                    </div>
                    <div>
                      <div>{{ getFullName(b) }}</div>
                      <div class="tx-color-03 tx-normal">
                        <template v-if="b.parentDepart!=undefined">{{b.parentDepart.name}} - </template>{{b.depart.name}} - {{ b.position }}
                      </div>
                    </div>
                  </div>
                </td>
                <td>{{ b.loginName }}</td>
                <td>{{ b.workStartDate | moment('YYYY.MM.DD') }}</td>
                <td>{{ b.status.statusName }}</td>
                <td>
                  <feather type="at-sign"></feather> Buddy-лах
                </td>
              </tr>
            </tbody>
          </table>

          <div class="d-flex justify-content-end mg-t-10 pgr-outer">
            <b-pagination
              v-model="pager.currentPage"
              :total-rows="buddiesCount"
              :per-page="pager.perPage"
              @change="pageChanged"
              first-number
              last-number
              align="center"
            ></b-pagination>
          </div>

        </div>
      </vue-custom-scrollbar>
    </div>

      <vue-custom-scrollbar
        class="lms-sidebar-right"
      >
        <div class="lms-sidebar-right-header">
          <div class="pos-absolute r-20 t-20">
            <div :class="`dropdown dropdown-profile`" v-show="$route.name=='buddyParticipant'">
                <a href class="dropdown-link" data-toggle="dropdown">
                  <img :src="`${myResBaseUrl}v4-assets/icon1.png`" />
                </a>
                <div class="divide-y dropdown-menu dropdown-menu-right tx-13">
                  <router-link to="/lms/profile" class="dropdown-item pd-l-0-f mg-b-15" role="button">
                    <feather type="user" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Профайл
                  </router-link>
                  <a @click="logout" class="dropdown-item pd-l-0-f mg-t-0-f" role="button">
                    <feather type="log-out" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Гарах
                  </a>
                </div>
              </div>
          </div>
          <a >
            <part-user-sidebar :mustJoinCourses="mustJoinCourses"></part-user-sidebar>
          </a>
        </div>
        
        <div class="lms-sidebar-right-body">

          <vc-calendar is-expanded title-position="left" color="red" /> 
        </div>

        <div class="lms-sidebar-right-footer">
        </div>
      </vue-custom-scrollbar>
    </div>

    

    <b-modal v-model="objFilterModal.modal" >
      <div v-if="objFilterModal.mode==1">
        <div class="form-group">
          <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Овог</label>
          <input v-model="listFilter.lastName" type="text" class="form-control" placeholder="Овог оруулна уу">
        </div>
        <div class="form-group">
          <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Нэр</label>
          <input v-model="listFilter.firstName" type="text" class="form-control" placeholder="Нэр оруулна уу">
        </div>
      </div>
      <div v-else-if="objFilterModal.mode==2">
        <div class="form-group">
          <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Домайн</label>
          <input v-model="listFilter.loginName" type="text" class="form-control" placeholder="Домайн оруулна уу">
        </div>
      </div>

      
      <template #modal-footer>
        <div class="btn-group">
          <button @click="objFilterModal.modal= false;" type="button" class="btn btn-white" data-dismiss="modal">Болих</button>
          <button @click="objFilterModal.modal= false; init()" type="button" class="btn btn-primary">Хайх</button>
        </div>
      </template>
    </b-modal>

    <b-modal v-model="chooseObj.modal" title="Томилох">
      <div class="form-group">
        <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Дадлагажих ажилтан</label>
        <div class="d-flex mg-y-6" v-if="chooseObj.modal">
          <div class="mg-r-10">
            <img :src="`${chooseObj.newbie.avator}`" class="wd-40 rounded-circle" />
          </div>
          <div>
            <div>{{ getFullName(chooseObj.newbie) }}</div>
            <div class="tx-color-03 tx-normal">
              <template v-if="chooseObj.newbie.parentDepart!=undefined">{{chooseObj.newbie.parentDepart.name}} - </template>{{chooseObj.newbie.depart.name}} - {{ chooseObj.newbie.position }}
            </div>
          </div>
        </div>
      </div>
      
      <div class="row bg-light">
        <div class="col-7">
          <div class="form-group">
            <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Дагуулж эхэлсэн огноо</label>
            <div class="" v-if="chooseObj.modal">
              <DatePicker
                v-model="chooseObj.dueStartDate"
                placeholder="Дагуулж эхэлсэн огноо"
                type="date"
                style="width: 100%"
                :format="'yyyy-MM-dd'"
                :value-format="'yyyy-MM-dd'"
              ></DatePicker>
            </div>
          </div>
        </div>
        <div class="col-5">
          <div class="form-group">
            <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Дагуулах хоног</label>
            <div v-if="chooseObj.modal">
              <InputNumber
                v-model="chooseObj.trialDays"
              ></InputNumber>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Buddy ажилтан сонгоно уу</label>
        <ul class="list-group">
          <li @click="chooseObj.buddyId=(chooseObj.buddyId!=b.id ? b.id : null)" role="button" :class="`list-group-item d-flex align-items-center ${b.id==chooseObj.buddyId?'bg-black-1':''}`" v-for="(b) in chooseObj.buddies">
            <div class="d-flex mg-y-6">
              <div class="mg-r-10">
                <img :src="`${b.avator}`" class="wd-40 rounded-circle" />
              </div>
              <div>
                <div>{{ getFullName(b) }}</div>
                <div class="tx-color-03 tx-normal">
                  <template v-if="b.departParent!=undefined">{{b.departParent.name}} - </template>{{b.depart.name}} - {{ b.position }}
                </div>
              </div>
            </div>
            <div class="pl-2 text-right border-l-4 mg-l-auto">
              <div class="tx-semibold tx-16">{{ b.activeNewbieCount }}</div>
              <div class="tx-color-03">Дадлагажигчтай</div>
            </div>
          </li>
        </ul>
      </div>
    
      <template #modal-footer>
        <div class="btn-group">
          <button @click="chooseObj.modal= false;" type="button" class="btn btn-white" data-dismiss="modal">Хаах</button>
          <button @click="assignBuddy()" type="button" class="btn btn-primary">Buddy-лах</button>
        </div>
      </template>
    </b-modal>

    <file-dialog
        :show="fileDialog.show"
        :id="fileDialog.id"
        @on-hide="fileDialog.show = false"
      />

  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

import "element-ui/lib/theme-chalk/index.css";
import { InputNumber, Autocomplete, MessageBox, Message, DatePicker } from "element-ui";

export default {
  components: {
    Autocomplete, MessageBox, DatePicker,Message, InputNumber,
    vueCustomScrollbar,
    departCascader: () => ({
      component: import("@/components/modules/hr/departCascader2"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    departCascader2: () => ({
      component: import("@/components/modules/hr/departCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    cardBuddy: () => ({
      component: import( "@/views/modules/lms/student/buddy/components/cardBuddy.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      loading: false,
      myResBaseUrl: "https://res.gosmart.mn/",
      mdlUpdateBuddy: false,
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      buddies: [],
      buddiesCount: null,
      buddiesAllCount: null,
      buddiesFetched: false,
      listFilterDepartKey: 0,
      pager:{
        perPage:10,
        currentPage: 1
      },
      listFilter:{
        departId: null,
        firstName: null,
        lastName: null,
        domain: null
      },
      workerFilterParam:{
        filter:{
          departId: null,
          loginName: null,
        }
      },
      objFilterModal:{
        mode: null,
        modal: false
      },
      isEditing: false,
      fileDialog: {
        id: null,
        show: false,
      },
      chooseObj:{
        buddies: [],
        newbie:{},
        buddyId: null,
        dueStartDate: moment().format("YYYY-MM-DD"),
        trialDays: 90,
        modal: false
      }
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    assignBuddy(){
      if(this.chooseObj.buddyId>0){
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Buddy/admin/SetBuddyToNewbie" },
          data: {
            buddyId: this.chooseObj.buddyId,
            newbieId: this.chooseObj.newbie.id,
            dueStartDate: this.chooseObj.dueStartDate,
            trialDays: this.chooseObj.trialDays > 0 ? this.chooseObj.trialDays : null,
            templateId: null,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if(res!=false){
            this.init();
            this.chooseObj.buddyId= null;
            this.chooseObj.trialDays= 90;
            this.chooseObj.dueStartDate= moment().format("YYYY-MM-DD");
            this.chooseObj.modal= false;
          }
        });
      } else {
        Message.warning("Buddy ажилтан сонгоно уу !");
      }
    },
    openFile(id){
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    exportBuddies(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "buddy/admin/exportBuddies" },
        data: {
          filter:this.listFilter
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.openFile(res.data.file.id);
        }
      });
    },
    gotoBuddyDetail(b){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "buddy/admin/getBuddies" },
        data: {
          pager:{
            skip: 0,
            size: 200,
          },
          filter:{
            departId: b.depart.id,
            // isBuddy: true,
            isActiveBuddy: true,
            domain: null,
            firstName: null,
            lastName:  null
          }
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.chooseObj.newbie= b;
          this.chooseObj.buddies= res.data.list;
          // this.chooseObj.dueStartDate= moment().format
          this.chooseObj.modal=true;
          // console.log('buddies', res.data);
        }
      });
      // this.$router.push({name: 'buddyAdminBuddyDetail',
      //   params:{
      //     id: b.id
      //   }
      // });
    },
    pageChanged(e){
      this.pager.currentPage = e;
      this.init();
    },
    openFilterModal(mode){
      this.objFilterModal.mode= mode;
      this.objFilterModal.modal= true;
    },
    getFullName(b){
      let rv=b.firstName.toUpperCase();
      if(b.lastName!=undefined && b.lastName!=null && b.lastName!='' && b.lastName.length){
        rv= b.lastName.charAt(0).toUpperCase() + '. ' +b.firstName;
      }
      return rv;
    },
    departListChanged(e){
      this.listFilter.departId= e;
      this.init();
    },
    departChanged(e){
      // console.log('departChanged', e);
      this.workerFilterParam.filter.departId= e;
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init(reset) {
      this.loading= true;

      this.buddiesFetched= false;

      if(reset!=undefined && reset){
        this.listFilterDepartKey++;
        this.listFilter={
          departId: null,
          firstName: null,
          lastName: null,
          domain: null
        };
      }
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "buddy/admin/GetBuddyNotSettedNewbies" },
        data: {
          pager:{
            skip: (this.pager.currentPage - 1) * this.pager.perPage,
            size: this.pager.perPage,
          },
          filter:this.listFilter
        },
        store: this.$store,
      }).then((res) => {
        this.loading= false;
        this.buddiesFetched= true;
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.buddies= res.data.list;
          this.buddiesCount= res.data.count;
          this.buddiesAllCount= res.data.allCount;
          // console.log('newbies', res.data);
        }
      });
    },
    
  },
};
</script>